export default function initFbPixel(pixelId) {
    // if (process.env.NODE_ENV === 'development') {
    //     console.info('[FB Pixel] Skipped in development mode.')
    //     return
    // }

    if (!pixelId) {
        console.warn('[FB Pixel] No Pixel ID provided.')
        return
    }

    if (window.fbq) {
        console.info('[FB Pixel] Already initialized.')
        return
    }

    ;(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n
        n.loaded = !0
        n.version = '2.0'
        n.queue = []
        t = b.createElement(e)
        t.async = !0
        t.src = 'https://connect.facebook.net/en_US/fbevents.js'
        s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
    })(window, document, 'script')

    window.fbq('init', pixelId)
    window.fbq('track', 'PageView')

    // console.info('[FB Pixel] Initialized with ID:', pixelId)
}
